import React, { useState, useEffect, useCallback } from 'react';
import {
  Box,
  Paper,
  Toolbar,
  Typography,
} from '@mui/material';

import { Page, EnhancedTable } from 'components';
import { DeviceInspect } from './components';

const formatDelay = (row, col) => {
  const val = row[col];
  return (<Box component="span" sx={{color: val > 0 ? 'error.main' : 'inherit'}}>{val === 0 ? '--' : val.toFixed(2)}</Box>);
};
const formatCtr = (row, _col) => row.ctr + ' / ' + (row.rt_imps > 0 ? 100*(row.rt_clicks|0)/row.rt_imps : 0).toFixed(2);
const formatRate = (row, col) => {
  const val = row[col];
  return val === 0 ? '--' : val.toFixed(4);
}
const formatProgress = (row, _col) => {
  const txt = (100*row.progress_real).toFixed(2) + ' / ' + (100*row.progress_need).toFixed(2);
  const hasError = Math.abs(row.progress_real-row.progress_need) > 0.13;
  return (<Box component="span" sx={{color: hasError ? 'error.main' : 'inherit'}}>{txt}</Box>);
}

const fcidStyles = {padding: '0 4px', cursor: 'pointer'};
const createFormatFcid = (setFcid) => (row, col) => (
  <span>{row[col]}
    <span style={fcidStyles} onClick={() => setFcid(row[col])}>📱</span>
  </span>
);

const columns = [
  { name: 'id', label: 'ID', numeric: true, sortable: true },
  { name: 'fc_id', label: 'FcID' },
  { name: 'name' },
  { name: 'day_imps', label: 'Plan Imps', numeric: true, sortable: true },
  { name: 'ctr', label: 'CTR (%)', format: formatCtr },
  { name: 'rt_imps', label: 'Imps', numeric: true },
  { name: 'rt_clicks', label: 'Clicks', numeric: true },
  { name: 'imp_rate', numeric: true, sortable: true, format: formatRate },
  { name: 'imp_delay', label: 'Imp Delay (s)', numeric: true, format: formatDelay },
  { name: 'clk_rate', numeric: true, sortable: true, format: formatRate },
  { name: 'clk_delay', label: 'Clk Delay (s)', numeric: true, format: formatDelay },
  { name: 'progress', label: 'Progress (%)', format: formatProgress },
];

const Systems = () => {
  const [accu, setAccuData] = useState([0, 0, 0, 0]);  // total, imps, clks, delayed
  const [fcid, setFcid] = useState(0);
  const [cols, setCols] = useState([]);

  useEffect(() => void(setCols(
    columns.map(col => col.name === 'fc_id' ? {...col, format: createFormatFcid(setFcid)} : col)
  )), []);

  const handleDataChange = useCallback((data) => {
    let total = 0, totImps = 0, totClks = 0, delayed = 0;
    data?.rows.forEach(row => {
      total += 1;
      if (row.imp_delay > 0 || row.clk_delay > 0) delayed += 1;
      totImps += row.imp_rate;
      totClks += row.clk_rate;
    });
    setAccuData([total, totImps, totClks, delayed]);
  }, []);
  const closeDeviceModal = useCallback(() => setFcid(0), []);

  return (
    <Page title="Systems">
      <Toolbar sx={{mt: -1}}>
        <Typography variant="h6" component="div" sx={{
          '& span': {
            padding: '3px 5px',
            marginRight: '10px',
            backgroundColor: theme => theme.vars.palette.app.metricBackground,
            fontWeight: 550,
            borderRadius: '5px',
          }
        }}>
          Total: <span>{accu[0]}</span>
          Imps: <span>{accu[1].toFixed(2)}</span>
          Clicks: <span>{accu[2].toFixed(2)}</span>
          Delayed: <span>{accu[3]}</span>
        </Typography>
      </Toolbar>
      <Paper sx={{p: 1, pb: 0, m: 2, mt: -1}}>
        <EnhancedTable
          stickyHeader
          columns={cols}
          dataUrl="/systems"
          refresh={60}
          dense={true}
          defaultOrderBy="-id"
          onDataChange={handleDataChange}
        />
      </Paper>
      <DeviceInspect fcid={fcid} onClose={closeDeviceModal} />
    </Page>
  );
};

export default Systems;
